const NAMESPACE = 'CARRIER_CONTACT';

const SET_CARRIER_CONTACT_CONTENT = `${NAMESPACE}/SET_CARRIER_CONTACT_CONTENT`;

export {
    SET_CARRIER_CONTACT_CONTENT,
};

export default NAMESPACE;
